import { Box, IconButton, Fade } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import ChatBodyNew from "./ChatBodyNew";
import { useScrollToLastSystemMessage } from "@root/hooks/useScrollToLastSystemMessage";
import { useScrollToBottomButton } from "@root/hooks/useScrollToBottomButton";

const ChatContent = ({
  data,
  showdefaultwelcometext,
  isRightPanelVisible = false,
}: {
  data: any;
  showdefaultwelcometext: boolean;
  isRightPanelVisible?: boolean;
}) => {
  const { scrollableDivRef, lastSystemMessageIndex } =
    useScrollToLastSystemMessage(data); // scroll to last system message and start streaming from top of the viewport

  const { showScrollButton, scrollToBottom } =
    useScrollToBottomButton(scrollableDivRef);

  return (
    <Box
      height={"100%"}
      overflow={"auto"}
      ref={scrollableDivRef}
      display={showdefaultwelcometext ? "none" : "block"}
      position="relative"
    >
      <Box maxWidth={"1000px"} mx={"auto"} px={"50px"} pb={"50px"}>
        {data?.map((item: any, i: number) => (
          <Box key={i}>
            <ChatBodyNew
              chat={item}
              isLastSystemMessage={i === lastSystemMessageIndex}
            />
          </Box>
        ))}
      </Box>

      {/* Scroll to Bottom Button */}
      <Fade in={showScrollButton} unmountOnExit>
        <IconButton
          aria-label="Scroll to bottom"
          icon={<ChevronDownIcon boxSize={6} />}
          onClick={scrollToBottom}
          position="fixed"
          bottom="140px"
          right={{
            base: isRightPanelVisible ? "420px" : "20px",
            md: isRightPanelVisible
              ? "calc((100vw - 1000px) / 2 + 420px)"
              : "calc((100vw - 1000px) / 2 + 20px)",
          }}
          borderRadius="50%"
          width="48px"
          height="48px"
          bg="rgba(26, 26, 26, 0.9)"
          color="white"
          boxShadow="0px 4px 12px rgba(0, 0, 0, 0.15)"
          backdropFilter="blur(8px)"
          _hover={{
            bg: "rgba(26, 26, 26, 1)",
            transform: "translateY(-2px) scale(1.05)",
            boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.25)",
          }}
          _active={{
            transform: "translateY(0px) scale(1)",
          }}
          transition="all 0.2s ease-in-out"
          zIndex={1000}
        />
      </Fade>
    </Box>
  );
};

export default ChatContent;
